/* global React, Icon, IconButton, Button, Modal, toast, COMPANY, useState */
// ============================================================
// PLUMME 2.0 — Skattemelding, steg 2: ekstra spesifikasjoner
// Data-drevet innhold for spesifikasjonene som legges til via
// "Legg til spesifikasjon" på Skattegrunnlag-steget.
// ============================================================

// schemes for "Mottak av skatte- og avgiftsordning omfattet av offentlig støtte"
const OFFENTLIG_SCHEMES = [
  'Rederiskatteordningen',
  'Gunstige avskrivningsregler for elvarebiler',
  'Skatteinsentivordning for langsiktige investeringer i oppstartsselskap',
  'Opsjon i arbeidsforhold i selskap i oppstarts- og vekstfasen',
  'Skattefunn',
  'Gunstige avskrivningsregler for LNG-anlegget (Snøhvit på Melkøya)',
  'Regionalt differensiert arbeidsgiveravgift',
  'Mva-fritak for omsetning av elbiler',
  'Mva-fritak for leasing av elbiler',
  'Redusert elavgift for industrien',
  'Redusert elavgift for fjernvarmeprodusenter',
  'Redusert elavgift i tiltakssonen',
  'Redusert elavgift til skip i næring',
  'Redusert elavgift til produksjon eller omforming av energiprodukt',
  'Fritak for eller redusert Co2-avgift på mineralolje og bensin som leveres til bruk som gir kvotepliktige utslipp etter klimakvoteloven',
  'Fritak for Co2-avgift på gass til bruk som gir kvotepliktige utslipp etter klimakvoteloven',
  'Fritak for NOX-avgift i henhold til miljøavtale mellom bedrifter og den norske stat',
  'Gunstige avskrivningsregler for vindkraft',
  'Mva-fritak for kjøretøy som bare bruker elektrisitet til framdrift, og hvor elektrisiteten er produsert i brenselceller (hydrogenbil)',
];

// row helpers: t = type
//   janei | num | text | locked | select | subhead | group | info | warn | table | scheme
const SPEC_SCHEMAS = {
  'Mottak av skatte- og avgiftsordning omfattet av offentlig støtte': [
    { t: 'janei', label: 'Har utestående betalingskrav knyttet til ulovlig utdelt statsstøtte' },
    { t: 'janei', label: 'Er liten eller mellomstor bedrift' },
    { t: 'janei', label: 'Var i økonomiske vansker ved sist avlagt regnskapsår' },
    { t: 'janei', label: 'Er i konsern' },
    { t: 'janei', label: 'Har mottatt annen offentlig støtte' },
    { t: 'scheme', label: 'Skatte og avgiftsordning', modalTitle: 'Skatte og avgiftsordning omfattet av offentlig støtte', options: OFFENTLIG_SCHEMES },
  ],

  'Forskning og utvikling (skattefunn)': [
    { t: 'info', text: 'Denne delen av skattemeldingen fylles bare ut av selskap som på forhånd har fått godkjent et SkatteFUNN-prosjekt. Godkjenningen må gjøres av Norges forskningsråd. SkatteFUNN er en ordning hvor selskapet kan få en del av kostnadene til et godkjent prosjekt dekket. Utbetalingen gjøres i forbindelse med selskapets skatteoppgjør på høsten, eller ved at skatten å betale reduseres.' },
    { t: 'group', label: 'Overordnet om prosjektet' },
    { t: 'num', label: 'Prosjektnummer', info: 'Prosjektnummer finner du for eksempel i godkjenningsbrevet for skattefunn-prosjektet fra Forskningsrådet.' },
    { t: 'text', label: 'Prosjekttittel', required: true },
    { t: 'text', label: 'Prosjektstatus', required: true },
    { t: 'group', label: 'Godkjent skattefunnperiode' },
    { t: 'text', label: 'Start', required: true, placeholder: 'dd.mm.åååå' },
    { t: 'text', label: 'Slutt', required: true, placeholder: 'dd.mm.åååå' },
    { t: 'group', label: 'Vurdering av økonomiske vanskeligheter' },
    { t: 'janei', label: 'Var i økonomiske vanskeligheter på søknadstidspunktet', preset: 'Nei' },
    { t: 'group', label: 'Annen offentlig støtte' },
    { t: 'janei', label: 'Har mottatt annen offentlig støtte i prosjektperioden', preset: 'Nei' },
    { t: 'group', label: 'Samarbeid med flere virksomheter' },
    { t: 'janei', label: 'Er samarbeid mellom flere virksomheter?', required: true },
    { t: 'group', label: 'Spesifikasjon av arbeidspakker' },
    { t: 'warn', text: 'Må ha minst én arbeidspakke' },
    { t: 'table', columns: ['Arbeidspakketittel', 'Arbeidspakke-ID', 'Kostnad i inntektsåret'] },
    { t: 'group', label: 'Skattefradrag for forskning og utvikling' },
    { t: 'select', label: 'Prosjekt skal bekreftes av revisor', options: ['Nei', 'Ja'] },
    { t: 'num', label: 'Netto skattefradrag før avkorting mot annen offentlig støtte' },
    { t: 'num', label: 'Skattefradrag per prosjekt', preset: '0,00' },
    { t: 'num', label: 'Tillegg i beregnet skatt per prosjekt' },
    { t: 'num', label: 'Samlet kostnad i hele prosjektperioden' },
  ],

  'Fradrag for skatt betalt i utlandet': [
    { t: 'locked', label: 'Samlet inntektsskatt betalt i utlandet' },
    { t: 'locked', label: 'Samlet formuesskatt betalt i utlandet' },
    { t: 'num', label: 'Korrigert nettoinntekt' },
    { t: 'locked', label: 'Samlet kostnad tilordnet utlandet etter indirekte fordelingsmetode' },
    { t: 'locked', label: 'Samlet kostnad tilordnet utlandet etter indirekte eller annen fordelingsmetode' },
    { t: 'locked', label: 'Bruttoformue i utlandet' },
    { t: 'group', label: 'Inntektsskatt betalt i utlandet' },
    { t: 'table', key: 'foreignIncomeTax', columns: ['Landkode', 'Type', 'Anvendt skattesats'] },
    { t: 'group', label: 'Resultat fra næringsvirksomhet i utlandet' },
    { t: 'num', label: 'Næringsinntekt' },
    { t: 'num', label: 'Underskudd' },
    { t: 'num', label: 'Samlet driftsinntekt' },
    { t: 'num', label: 'Samlet driftskostnad' },
    { t: 'num', label: 'Samlet finansinntekt' },
    { t: 'num', label: 'Samlet finanskostnad' },
    { t: 'group', label: 'Fremført utenlandsk skatt per inntektsår' },
    { t: 'table', columns: ['Inntektsår', 'Fremført utenlandsk formuesskatt', 'Fremført utenlandsk inntektsskatt'] },
    { t: 'group', label: 'Formuesskatt betalt i utlandet' },
    { t: 'table', key: 'foreignWealthTax', columns: ['Landkode', 'Type', 'Anvendt skattesats'] },
    { t: 'group', label: 'Fordeling av kostnad' },
    { t: 'table', columns: ['Type', 'Beløp', 'Andel av kostnad tilordnet utlandet', 'Beløp tilordnet utlandet', 'Kostnadsfordelingsmetode'] },
    { t: 'group', label: 'Korrigering i inntekt' },
    { t: 'num', label: 'Utbytte fra utenlandsk datterselskap' },
    { t: 'num', label: 'Inntekt underlagt kildeskatt i utlandet' },
    { t: 'num', label: 'Fremførbart underskudd i inntekt tilordnet utlandet' },
    { t: 'num', label: 'Mottatt konsernbidrag tilordnet utlandet' },
    { t: 'group', label: 'Formuesobjekt underlagt beskatning i utlandet' },
    { t: 'table', columns: ['Type', 'Beløp'] },
  ],

  'Fradrag for skattelegging av utbytte mv. fra utenlandsk datterselskap': [
    { t: 'num', label: 'Fremført ubenyttet underliggende selskapsskatt fom 1995' },
    { t: 'num', label: 'Fradragsberettiget andel av underliggende selskapsskatt i inntektsåret' },
    { t: 'num', label: 'Anvendt fradragsberettiget andel av underliggende selskapsskatt i inntektsåret' },
  ],

  'Tilbakeført utenlandsk skatt senere år': [
    { t: 'num', label: 'Tilbakeført utenlandsk skatt', required: true },
  ],

  'Konsernbidrag': [
    { t: 'num', label: 'Mottatt konsernbidrag som er skattepliktig inntekt' },
    { t: 'num', label: 'Mottatt konsernbidrag uten skatteeffekt' },
    { t: 'num', label: 'Avgitt konsernbidrag som gir skattemessig fradrag' },
    { t: 'num', label: 'Avgitt konsernbidrag uten skatteeffekt' },
  ],
};

// — small bits —————————————————————————————————————————————
function ReqBadge() { return <span className="cl-req">{t('clo.required')}</span>; }
function InfoDot({ text }) { return <span className="cl-info-dot" title={text || ''}><Icon name="info" size={15} /></span>; }

// expandable detail row — radio (janei) or input (num/text)
function DetailEditRow({ row, value, onChange }) {
  // NB: feltet heter `t` i datamodellen - aliaseres for aa ikke skygge global t().
  const { t: rowType, label, required, info, preset, placeholder } = row;
  const [open, setOpen] = useState(false);
  const [localValue, setLocalValue] = useState(null);          // null = not provided
  const current = onChange ? value : localValue;
  const setValue = (next) => onChange ? onChange(next) : setLocalValue(next);
  const display = current == null || current === '' ? '–' : current;
  const startAdd = () => setValue(rowType === 'janei' ? (preset || 'Nei') : (preset || ''));
  const removeChange = () => { setValue(null); };

  return <div className={'cl-usk-row cl-srow' + (open ? ' open' : '')}>
    <div className="cl-usk-main">
      <span className="cl-usk-label">{label}{required ? <ReqBadge /> : null}{info ? <InfoDot text={info} /> : null}</span>
      <span className="cl-usk-val">
        <strong className={display === '–' ? 'is-muted' : ''}>{display}</strong>
        <button className="cl-edit-link" onClick={() => setOpen((o) => !o)}>{t('clo.change')}</button>
      </span>
    </div>
    {open ? <div className="cl-usk-detail">
      {current == null ? <div className="cl-usk-detail-actions">
        <Button size="sm" variant="secondary" icon="plus" onClick={startAdd}>{t('list.add')}</Button>
      </div> : <>
        {info ? <p className="cl-srow-info">{info}</p> : null}
        <span className="cl-usk-detail-h">{t('sale.step.detaljer')}</span>
        <div className="cl-usk-detail-row">
          <span>{t('clo.addedByUser')}</span>
          {rowType === 'janei'
            ? <div className="cl-radio-group">
                {['Ja', 'Nei'].map((opt) => <label key={opt} className={'cl-radio' + (current === opt ? ' on' : '')}>
                  <input type="radio" name={label} checked={current === opt} onChange={() => setValue(opt)} />
                  <span className="cl-radio-dot" /><span className="cl-radio-lbl">{opt}</span>
                </label>)}
              </div>
            : <input className="input cl-usk-input" inputMode={rowType === 'num' ? 'decimal' : 'text'} autoFocus
                placeholder={placeholder || (rowType === 'num' ? '0,00' : '')} value={current || ''} onChange={(e) => setValue(e.target.value)} />}
        </div>
        <div className="cl-usk-detail-actions">
          <Button size="sm" variant="secondary" icon="x" onClick={removeChange}>{t('clo.removeChange')}</Button>
        </div>
      </>}
    </div> : null}
  </div>;
}

// read-only locked row (computed by Plumme)
function LockedRow({ row }) {
  return <div className="cl-usk-row cl-srow is-locked">
    <div className="cl-usk-main">
      <span className="cl-usk-label">{row.label}{row.info ? <InfoDot text={row.info} /> : null}</span>
      <span className="cl-usk-val"><strong className="is-muted">–</strong><Icon name="lock" size={16} className="cl-lock" /></span>
    </div>
  </div>;
}

// inline select row
function SelectRow({ row, value, onChange }) {
  const [localValue, setLocalValue] = useState(row.options[0]);
  const current = onChange ? (value || row.options[0]) : localValue;
  const setValue = (next) => onChange ? onChange(next) : setLocalValue(next);
  return <div className="cl-usk-row cl-srow">
    <div className="cl-usk-main">
      <span className="cl-usk-label">{row.label}{row.info ? <InfoDot text={row.info} /> : null}</span>
      <select className="input cl-srow-select" value={current} onChange={(e) => setValue(e.target.value)}>
        {row.options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  </div>;
}

// column-headed sub-table with "Legg til"
function SpecTable({ row, rows, onChange }) {
  const [localRows, setLocalRows] = useState([]);
  const currentRows = onChange ? (Array.isArray(rows) ? rows : []) : localRows;
  const setRows = (next) => onChange ? onChange(next) : setLocalRows(next);
  const addRow = () => setRows([...currentRows, row.columns.map(() => '')]);
  const updateCell = (rowIndex, columnIndex, value) => setRows(currentRows.map((entry, index) => index === rowIndex ? entry.map((cell, cellIndex) => cellIndex === columnIndex ? value : cell) : entry));
  const deleteRow = (rowIndex) => setRows(currentRows.filter((_, index) => index !== rowIndex));
  return <div className="cl-spectable">
    <div className="cl-spectable-cols">
      {row.columns.map((c) => <div key={c} className="cl-spectable-col">{c}</div>)}
    </div>
    {currentRows.map((entry, rowIndex) => <div key={rowIndex} className="cl-spectable-edit-row">
      {row.columns.map((column, columnIndex) => <input key={column} className="input" value={entry[columnIndex] || ''} placeholder={column} onChange={(event) => updateCell(rowIndex, columnIndex, event.target.value)} />)}
      <IconButton name="trash" size="sm" variant="ghost" onClick={() => deleteRow(rowIndex)} />
    </div>)}
    <Button size="sm" variant="secondary" icon="plus" onClick={addRow}>{t('list.add')}</Button>
  </div>;
}

// modal to choose a scheme
function SchemeModal({ title, options, entry, onClose, onSave, onDelete }) {
  const [value, setValue] = useState(entry ? entry.value : options[0]);
  const original = entry ? entry.value : options[0];
  return <Modal open={true} onClose={onClose} title={title} max={620}
    footer={<div className="cl-modal-ft">
      <Button variant="ghost" icon="trash" onClick={onDelete || undefined} style={onDelete ? null : { visibility: 'hidden' }}>{t('list.delete')}</Button>
      <div className="row gap-12"><button className="cl-edit-link" onClick={onClose}>{t('common.cancel')}</button><Button onClick={() => onSave(value)}>{t('sale.save')}</Button></div>
    </div>}>
    <div className="cl-scheme-modal">
      <div className="cl-detail-row"><div className="cl-detail-left"><span>{t('spx.taxScheme')}</span></div><strong>{value}</strong></div>
      <span className="cl-usk-detail-h" style={{ marginTop: 4 }}>{t('sale.step.detaljer')}</span>
      <div className="cl-usk-detail-row">
        <span>{t('clo.addedByUser')}</span>
        <select className="input" style={{ maxWidth: 360 }} value={value} onChange={(e) => setValue(e.target.value)}>
          {options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      </div>
      {value !== original ? <div className="cl-usk-detail-actions">
        <Button size="sm" variant="secondary" icon="x" onClick={() => setValue(original)}>{t('clo.removeChange')}</Button>
      </div> : null}
    </div>
  </Modal>;
}

// repeatable scheme list
function SchemeBlock({ row, entries, onChange }) {
  const [localEntries, setLocalEntries] = useState([]);
  const currentEntries = onChange ? (Array.isArray(entries) ? entries : []) : localEntries;
  const setEntries = (next) => onChange ? onChange(next) : setLocalEntries(next);
  const [modal, setModal] = useState(null); // {entry} | {new:true} | null
  const save = (value) => {
    const next = modal && modal.entry
      ? currentEntries.map((entry) => entry.id === modal.entry.id ? { ...entry, value } : entry)
      : [...currentEntries, { id: 'sc' + Date.now(), value }];
    setEntries(next);
    setModal(null); toast(t('r1e.spec.schemeSaved'), 'success');
  };
  const del = () => { setEntries(currentEntries.filter((entry) => entry.id !== modal.entry.id)); setModal(null); toast(t('r1e.spec.schemeRemoved'), 'success'); };
  return <div className="cl-scheme">
    <div className="cl-spec-sub">{row.label}</div>
    {currentEntries.map((en) => <button key={en.id} className="cl-scheme-row" onClick={() => setModal({ entry: en })}>
      <span>{en.value}</span><Icon name="penBox" size={17} className="cl-lock" />
    </button>)}
    <div className="cl-scheme-add"><Button variant="ghost" icon="plus" onClick={() => setModal({ new: true })}>{t('list.add')}</Button></div>
    {modal ? <SchemeModal title={row.modalTitle || row.label} options={row.options}
      entry={modal.entry} onClose={() => setModal(null)} onSave={save} onDelete={modal.entry ? del : null} /> : null}
  </div>;
}

// — main —————————————————————————————————————————————————
function ExtraSpecContent({ title, value, onChange: persist, onRemove }) {
  const [draft, setDraft] = useState(value || {});
  const [saving, setSaving] = useState(false);
  const onChange = setDraft;
  const commit = async () => { if (saving) return; setSaving(true); try { await persist(draft); } finally { setSaving(false); } };
  const schema = SPEC_SCHEMAS[title] || Object.entries(SPEC_SCHEMAS).find(([key]) => window.PlummeTaxSpecifications.id(key) === window.PlummeTaxSpecifications.id(title))?.[1];
  const specValue = draft;
  const fields = specValue.fields || {};
  const tables = specValue.tables || {};
  const schemes = specValue.schemes || {};
  const saveField = (key, nextValue) => onChange && onChange({ ...specValue, fields: { ...fields, [key]: nextValue } });
  const saveTable = (key, rows) => onChange && onChange({ ...specValue, tables: { ...tables, [key]: rows } });
  const saveScheme = (key, rows) => onChange && onChange({ ...specValue, schemes: { ...schemes, [key]: rows } });
  if (!schema) {
    return <>
      <p>{t('r1e.spec.addedBody', { company: COMPANY.name })}</p>
      <div className="cl-permlist"><div className="cl-permlist-empty">{t('spx.noItems')}</div></div>
      <div className="cl-scheme-foot"><Button size="sm" disabled={saving} onClick={commit}>{t('clo.save')}</Button><Button size="sm" disabled={saving} variant="ghost" icon="trash" onClick={onRemove}>{t('spx.removeSpec')}</Button></div>
    </>;
  }
  return <div className="cl-speccontent">
    {tables['Landkode|Type|Anvendt skattesats']?.length ? <div role="alert"><p>{t('clo.legacyForeignTaxReview', 'Earlier foreign-tax rows need review. They have not been assigned to income tax or wealth tax.')}</p><SpecTable row={{ columns: ['Landkode', 'Type', 'Anvendt skattesats'] }} rows={tables['Landkode|Type|Anvendt skattesats']} onChange={(rows) => saveTable('Landkode|Type|Anvendt skattesats', rows)} /></div> : null}
    {schema.map((row, i) => {
      const fieldKey = row.label || `${row.t}-${i}`;
      const tableKey = row.key || (row.columns ? row.columns.join('|') : fieldKey);
      switch (row.t) {
        case 'info': return <div key={i} className="cl-spec-info">{row.text}</div>;
        case 'warn': return <div key={i} className="cl-spec-warn">{row.text}</div>;
        case 'group': return <div key={i} className="cl-spec-group">{row.label}</div>;
        case 'janei':
        case 'num':
        case 'text': return <DetailEditRow key={i} row={row} value={fields[fieldKey]} onChange={(next) => saveField(fieldKey, next)} />;
        case 'locked': return <LockedRow key={i} row={row} />;
        case 'select': return <SelectRow key={i} row={row} value={fields[fieldKey]} onChange={(next) => saveField(fieldKey, next)} />;
        case 'table': return <SpecTable key={i} row={row} rows={tables[tableKey]} onChange={(rows) => saveTable(tableKey, rows)} />;
        case 'scheme': return <SchemeBlock key={i} row={row} entries={schemes[fieldKey]} onChange={(rows) => saveScheme(fieldKey, rows)} />;
        default: return null;
      }
    })}
    <div className="cl-scheme-foot"><Button size="sm" disabled={saving} onClick={commit}>{t('clo.save')}</Button><Button size="sm" disabled={saving} variant="ghost" icon="trash" onClick={onRemove}>{t('spx.removeSpec')}</Button></div>
  </div>;
}

Object.assign(window, { ExtraSpecContent, SPEC_SCHEMAS });
